import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'lowerCase', standalone: true })
@Injectable({providedIn: 'root'})
export class LowerCasePipe implements PipeTransform {
	
	transform(string) {
		return string.toLowerCase();
	}
	
}